module.exports = __webpack_public_path__ + "img/公告1.a6248c0a.jpg";